import { useAuth } from 'oidc-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { bindAccountOwner } from 'src/store/actions';

/**
 * R43 → R56-9: the session-persisted store belongs to the signed-in user — a sign-in of another
 * user (or a sign-out) in the same tab resets it, so no data of the previous account (addresses,
 * payment methods, cart, customer data …) reaches the next one.
 */
export function useAccountOwner(): void {
    const auth = useAuth();
    const dispatch = useDispatch();
    const isLoading = auth?.isLoading ?? true;
    const subject = auth?.userData?.profile?.sub ?? null;

    useEffect(() => {
        if (isLoading) return;
        dispatch(bindAccountOwner(subject));
    }, [isLoading, subject, dispatch]);
}
